/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.18",
    versionName: "0.2.0-nightly.2025.11.18",
    versionChannel: "nightly",
    buildDate: "2025-11-18T00:07:53.721Z",
    commitHash: "3a9b35ecb0e12d01ec58fe5e5b07c45663bc79f8",
};
